import { Attributes, DateUtils, Misc, Model, Rules, Validation } from "@singularsystems/neo-core";

export default class AuditTrailCriteria extends Model.CriteriaBase {
    static typeName = "AuditTrailCriteria";

    constructor() {
        super();
        this.makeObservable();
    }
    
    @Attributes.Nullable()
    public tableName: string = "";

    @Attributes.Nullable()
    public userId: number | null = null;

    @Attributes.Nullable()
    public tableId: number | null = null;

    @Attributes.Nullable()
    public userName: string = "";

    @Rules.Required()   
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Audit Trail Criteria";
    }
}